import { normalizeImageSrc } from './imageUrl';

const failedUrls = new Set<string>();

export function markImageUrlFailed(url: string | null | undefined): void {
  const normalized = normalizeImageSrc(url);
  if (normalized) failedUrls.add(normalized);
}

export function isImageUrlFailed(url: string | null | undefined): boolean {
  const normalized = normalizeImageSrc(url);
  return normalized ? failedUrls.has(normalized) : false;
}

export function filterViableImageCandidates(urls: string[]): string[] {
  return urls.filter((url) => !isImageUrlFailed(url));
}

/** Test helper */
export function clearFailedImageUrlsForTests(): void {
  failedUrls.clear();
}
